export default {
    validation: {
        amountRequired: 'Please enter a valid amount',
        amountPattern: 'Please enter a valid amount',
        maxLength: 'The amount can\'t be higher than the outstanding balance plus €100',
        minLength: 'Please enter a valid amount',
    }
}